import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

interface Props {
  to: string;
}

export default function RedirectSchoolSchoolyear(props: Props) {
  const { to } = props;
  const { school, schoolyear } = useSchoolSchoolyear();

  return (
    <Navigate
      to={`/annee-scolaire/${schoolyear.id}/ecole/${school.id}/${to}`}
      replace
    />
  );
}
